import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "./../../core/services/auth.service";
import { UserProfileService } from "./../../core/services/user.service";
import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
} from "@angular/core";
import MetisMenu from "metismenujs/dist/metismenujs";
import { EventService } from "../../core/services/event.service";
import { Router, NavigationEnd } from "@angular/router";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { AuthService } from "src/app/core/services/auth/auth.service";
import { PERMISSIONS } from "../../core/models/permissions.models";
import { getRequiredPermissions } from "../../core/models/route-permissions.model";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() isCondensed = false;

  menu: any;

  menuItems = [];
  configData;

  @ViewChild("sideMenu") sideMenu: ElementRef;

  def_menu = [];

  su_menuobj = [
    { type: "head", class: "menu-title", span: "RevIoT Box" },
    {
      type: "elm",
      link: "/su_dashboard",
      class: "bx bx-line-chart bx-tada-hover",
      span: "Dashboard",
    },
    {
      type: "elm",
      link: "/su_alarms",
      class: "bx bx-bell bx-tada-hover",
      span: this.translate.instant("sidebar.sa"),
    },
    {
      type: "elm",
      link: "/su_expiration",
      class: "bx bx-rocket bx-tada-hover",
      span: this.translate.instant("sidebar.e"),
    },
    {
      type: "elm",
      link: "/su_boxes",
      class: "bx bx-box bx-tada-hover",
      span: this.translate.instant("sidebar.ab"),
    },
    {
      type: "elm",
      link: "/su_orders",
      class: "bx bx-file-find bx-tada-hover",
      span: this.translate.instant("sidebar.ao"),
    },
    {
      type: "elm",
      link: "/su_pboxes",
      class: "bx bx-hourglass bx-tada-hover",
      span: this.translate.instant("sidebar.pb"),
    },
    {
      type: "elm",
      link: "/su_archive",
      class: "bx bx-folder bx-tada-hover",
      span: this.translate.instant("sidebar.ba"),
    },
    {
      type: "elm",
      link: "/su_devs",
      class: "bx bx-chip bx-tada-hover",
      span: this.translate.instant("sidebar.d"),
    },
    {
      type: "elm",
      link: "/su_fw_builds",
      class: "bx bx-save bx-tada-hover",
      span: "Firmware",
    },
    { type: "head", class: "menu-title", span: "RevIoT Box Light" },
    {
      type: "elm",
      link: "/su_light_boxes",
      class: "bx bx-broadcast bx-tada-hover",
      span: "Light Boxes",
    },
    {
      type: "elm",
      link: "/su_light_batches",
      class: "bx bx-layer bx-tada-hover",
      span: "Light Batches",
    },
    {
      type: "elm",
      link: "/su_light_customers",
      class: "bx bx-group bx-tada-hover",
      span: "Light Customers",
    },
    {
      type: "elm",
      link: "/su_light_devices",
      class: "bx bx-bluetooth bx-tada-hover",
      span: "Light Devices",
    },
    {
      type: "elm",
      link: "/su_pallets",
      class: "bx bx-cube bx-tada-hover",
      span: "Pallet",
    },
    { type: "head", class: "menu-title", span: "Spare Parts" },
    {
      type: "elm",
      link: "/spare_parts_boxes",
      class: "bx bx-package bx-tada-hover",
      span: "Spare Parts Boxes",
    },
    {
      type: "elm",
      link: "/spare_parts_expiration",
      class: "bx bx-calendar-event bx-tada-hover",
      span: this.translate.instant("sidebar.spe"),
    },
    {
      type: "elm",
      link: "/spare_parts_projects",
      class: "bx bx-list-ul bx-tada-hover",
      span: "Spare Parts Projects",
    },
    {
      type: "elm",
      link: "/spare_parts_safety_stock",
      class: "bx bx-shield-alt-2 bx-tada-hover",
      span: this.translate.instant("sidebar.sss"),
    },
    {
      type: "elm",
      link: "/spare_parts_product_list",
      class: "bx bx-list-check bx-tada-hover",
      span: this.translate.instant("sidebar.spl"),
    },
    { type: "head", class: "menu-title", span: "Admin" },
    {
      type: "elm",
      link: "/su_users",
      class: "bx bx-id-card bx-tada-hover",
      span: this.translate.instant("sidebar.u"),
    },
  ];

  pu_menuobj = [
    { type: "head", class: "menu-title", span: "RevIoT Box" },
    {
      type: "elm",
      link: "/su_dashboard",
      class: "bx bx-line-chart bx-tada-hover",
      span: "Dashboard",
    },
    {
      type: "elm",
      link: "/su_alarms",
      class: "bx bx-bell bx-tada-hover",
      span: this.translate.instant("sidebar.sa"),
    },
    {
      type: "elm",
      link: "/su_expiration",
      class: "bx bx-rocket bx-tada-hover",
      span: this.translate.instant("sidebar.e"),
    },
    {
      type: "elm",
      link: "/su_boxes",
      class: "bx bx-box bx-tada-hover",
      span: this.translate.instant("sidebar.ab"),
    },
    {
      type: "elm",
      link: "/su_orders",
      class: "bx bx-file-find bx-tada-hover",
      span: this.translate.instant("sidebar.ao"),
    },
    {
      type: "elm",
      link: "/su_pboxes",
      class: "bx bx-hourglass bx-tada-hover",
      span: this.translate.instant("sidebar.pb"),
    },
    {
      type: "elm",
      link: "/su_archive",
      class: "bx bx-folder bx-tada-hover",
      span: this.translate.instant("sidebar.ba"),
    },
    { type: "head", class: "menu-title", span: "RevIoT Box Light" },
    {
      type: "elm",
      link: "/su_light_boxes",
      class: "bx bx-broadcast bx-tada-hover",
      span: "Light Boxes",
    },
    {
      type: "elm",
      link: "/su_light_batches",
      class: "bx bx-layer bx-tada-hover",
      span: "Light Batches",
    },
    {
      type: "elm",
      link: "/su_light_customers",
      class: "bx bx-group bx-tada-hover",
      span: "Light Customers",
    },
    {
      type: "elm",
      link: "/su_light_devices",
      class: "bx bx-bluetooth bx-tada-hover",
      span: "Light Devices",
    },
    {
      type: "elm",
      link: "/su_pallets",
      class: "bx bx-cube bx-tada-hover",
      span: "Pallet",
    },
    { type: "head", class: "menu-title", span: "Spare Parts" },
    {
      type: "elm",
      link: "/spare_parts_boxes",
      class: "bx bx-package bx-tada-hover",
      span: "Spare Parts Boxes",
    },
    {
      type: "elm",
      link: "/spare_parts_expiration",
      class: "bx bx-calendar-event bx-tada-hover",
      span: this.translate.instant("sidebar.spe"),
    },
    {
      type: "elm",
      link: "/spare_parts_projects",
      class: "bx bx-list-ul bx-tada-hover",
      span: "Spare Parts Projects",
    },
    {
      type: "elm",
      link: "/spare_parts_safety_stock",
      class: "bx bx-shield-alt-2 bx-tada-hover",
      span: this.translate.instant("sidebar.sss"),
    },
    {
      type: "elm",
      link: "/spare_parts_product_list",
      class: "bx bx-list-check bx-tada-hover",
      span: this.translate.instant("sidebar.spl"),
    },
    { type: "head", class: "menu-title", span: "Admin" },
    {
      type: "elm",
      link: "/su_users",
      class: "bx bx-id-card bx-tada-hover",
      span: this.translate.instant("sidebar.u"),
    }
  ];

  cu_menuobj = [
    { type: "head", class: "menu-title", span: "Menu" },
    {
      type: "elm",
      link: "/cu_expiration",
      class: "bx bx-rocket bx-tada-hover",
      span: this.translate.instant("sidebar.e"),
    },
    {
      type: "elm",
      link: "/cu_boxes",
      class: "bx bx-box bx-tada-hover",
      span: this.translate.instant("sidebar.ab"),
    },
    {
      type: "elm",
      link: "/cu_orders",
      class: "bx bx-file-find bx-tada-hover",
      span: this.translate.instant("sidebar.ao"),
    },
    {
      type: "elm",
      link: "/cu_archive",
      class: "bx bx-folder bx-tada-hover",
      span: this.translate.instant("sidebar.ba"),
    },
  ];

  pe_menuobj = [{ type: "head", class: "menu-title", span: "Menu" }];

  constructor(
    private eventService: EventService,
    private router: Router,
    private auth: AuthenticationService,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit() {
    this.initialize();

    document.body.setAttribute("data-sidebar", "light");

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.updateMenuForUser();

    // Subscribe to language changes to update menu items
    this.translate.onLangChange.subscribe(() => {
      this.updateMenuItems();
      this.updateMenuForUser();
    });
  }

  updateMenuForUser() {
    const user = this.authService.getUserInfo();
    console.log('updateMenuForUser called, user:', user);
    
    if (!user) {
      console.log('No user found, showing pending menu');
      this.def_menu = this.pe_menuobj;
      return;
    }

    // SuperUser sees all menu items
    const isSuper = this.authService.isSuperUser();
    console.log('Is SuperUser?', isSuper, 'Role:', user.roleName, 'Permissions:', user.permissions);
    
    if (isSuper) {
      console.log('User is SuperUser, showing all menu items');
      this.def_menu = this.su_menuobj;
      return;
    }

    // Build menu based on permissions
    console.log('Filtering menu based on permissions. User permissions:', user.permissions);
    const allMenuItems = [...this.su_menuobj];
    this.def_menu = this.filterMenuByPermissions(allMenuItems, user);
    console.log('Filtered menu items:', this.def_menu.length, 'items');

    // If no menu items after filtering, show pending menu
    if (this.def_menu.length === 0 || (this.def_menu.length === 1 && this.def_menu[0].type === "head")) {
      console.log('No menu items after filtering, showing pending menu');
      this.def_menu = this.pe_menuobj;
    }
  }

  private filterMenuByPermissions(menuItems: any[], user: any): any[] {
    console.log('filterMenuByPermissions called with', menuItems.length, 'items');
    const filtered: any[] = [];
    let pendingSection: any = null;
    let hasItemsInPendingSection = false;
    const addedSections = new Set<string>(); // Track added section headers by their span text

    for (let i = 0; i < menuItems.length; i++) {
      const item = menuItems[i];
      
      // Handle section headers
      if (item.type === "head") {
        // If we have a pending section with items, add it before starting a new section
        if (pendingSection && hasItemsInPendingSection) {
          const sectionKey = pendingSection.span || '';
          // Only add if we haven't already added this section header
          if (sectionKey && !addedSections.has(sectionKey)) {
            filtered.push(pendingSection);
            addedSections.add(sectionKey);
          }
        }
        // Start tracking a new section (don't add it yet - wait for items)
        pendingSection = item;
        hasItemsInPendingSection = false;
        continue;
      }

      // Check if user has permission for this menu item
      if (item.link) {
        const requiredPermissions = getRequiredPermissions(item.link);
        
        // Only show menu items if user has the required permissions
        // Public routes (like /pe_landing) have empty permissions array and are allowed
        const isPublicRoute = item.link === '/pe_landing' || item.link.startsWith('/account/');
        
        let shouldShowItem = false;
        
        if (requiredPermissions.length === 0) {
          // Only allow explicitly public routes
          shouldShowItem = isPublicRoute;
          console.log(`Menu item ${item.link}: No permissions required, isPublicRoute=${isPublicRoute}, showing=${shouldShowItem}`);
        } else {
          // User must have at least one of the required permissions
          // SuperUser automatically has all permissions, but regular users must have the specific permission
          shouldShowItem = this.authService.hasAnyPermission(requiredPermissions);
          const userPerms = this.authService.getUserInfo()?.permissions || [];
          console.log(`Menu item ${item.link}: Required permissions: [${requiredPermissions.join(', ')}], User has: [${userPerms.join(', ')}], Showing: ${shouldShowItem}`);
          
          // Debug: Log if a user without permission is trying to see a restricted route
          if (!shouldShowItem && !this.authService.isSuperUser()) {
            console.warn(`Hiding menu item ${item.link} - Required: ${requiredPermissions.join(', ')}, User has: ${userPerms.join(', ')}`);
          }
        }
        
        if (shouldShowItem) {
          // Add pending section header if we haven't already (only when we have the first item)
          if (pendingSection && !hasItemsInPendingSection) {
            const sectionKey = pendingSection.span || '';
            // Only add if we haven't already added this section header
            if (sectionKey && !addedSections.has(sectionKey)) {
              filtered.push(pendingSection);
              addedSections.add(sectionKey);
              hasItemsInPendingSection = true;
            } else if (sectionKey && addedSections.has(sectionKey)) {
              // Section already added, just mark that we have items
              hasItemsInPendingSection = true;
            }
          }
          filtered.push(item);
        }
      } else {
        // Items without links (like separators) are included
        if (pendingSection && !hasItemsInPendingSection) {
          const sectionKey = pendingSection.span || '';
          if (sectionKey && !addedSections.has(sectionKey)) {
            filtered.push(pendingSection);
            addedSections.add(sectionKey);
            hasItemsInPendingSection = true;
          }
        }
        filtered.push(item);
      }
    }

    // Don't add the last pending section header if there are no items in that section
    // Remove any trailing section headers (headers at the end with no items after them)
    while (filtered.length > 0 && filtered[filtered.length - 1]?.type === "head") {
      filtered.pop();
    }

    return filtered;
  }
  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast("changeLayout", layout);
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);

    this._activateMenuDropdown();
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute("data-sidebar", "light");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar-size");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.classList.remove("vertical-collpsed");
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute("data-sidebar-size", "small");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-topbar");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("vertical-collpsed");
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add("sidebar-enable");
    document.body.classList.add("vertical-collpsed");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.removeAttribute("data-topbar");
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute("data-keep-enlarged", "true");
    document.body.setAttribute("data-layout-size", "boxed");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.classList.add("vertical-collpsed");
    document.body.classList.remove("sidebar-enable");
    document.body.removeAttribute("data-topbar");
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute("data-sidebar", "colored");
    document.body.removeAttribute("data-sidebar-size");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("vertical-collpsed");
    document.body.removeAttribute("data-topbar");
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass("mm-active");
    this._removeAllClass("mm-show");
    const links = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (window.location.pathname === links[i]["pathname"]) {
        menuItemEl = links[i];
        break;
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add("mm-active");

        const parent2El = parentEl.parentElement.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;

          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");

            if (childAnchor) {
              childAnchor.classList.add("mm-active");
            }
            if (childDropdown) {
              childDropdown.classList.add("mm-active");
            }

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Update menu items with current translations
   */
  updateMenuItems() {
    // Update SuperUser menu
    this.su_menuobj[1].span = this.translate.instant("sidebar.sa");
    this.su_menuobj[2].span = this.translate.instant("sidebar.e");
    this.su_menuobj[3].span = this.translate.instant("sidebar.ab");
    this.su_menuobj[4].span = this.translate.instant("sidebar.ao");
    this.su_menuobj[5].span = this.translate.instant("sidebar.pb");
    this.su_menuobj[6].span = this.translate.instant("sidebar.ba");
    this.su_menuobj[7].span = this.translate.instant("sidebar.d");
    this.su_menuobj[18].span = this.translate.instant("sidebar.spe");
    this.su_menuobj[20].span = this.translate.instant("sidebar.sss");
    this.su_menuobj[21].span = this.translate.instant("sidebar.spl");
    this.su_menuobj[23].span = this.translate.instant("sidebar.u");

    // Update PlantAdmin menu
    this.pu_menuobj[1].span = this.translate.instant("sidebar.sa");
    this.pu_menuobj[2].span = this.translate.instant("sidebar.e");
    this.pu_menuobj[3].span = this.translate.instant("sidebar.ab");
    this.pu_menuobj[4].span = this.translate.instant("sidebar.ao");
    this.pu_menuobj[5].span = this.translate.instant("sidebar.pb");
    this.pu_menuobj[6].span = this.translate.instant("sidebar.ba");
    this.pu_menuobj[16].span = this.translate.instant("sidebar.spe");
    this.pu_menuobj[18].span = this.translate.instant("sidebar.sss");
    this.pu_menuobj[19].span = this.translate.instant("sidebar.spl");
    this.pu_menuobj[21].span = this.translate.instant("sidebar.u");

    // Update Customer menu
    this.cu_menuobj[1].span = this.translate.instant("sidebar.e");
    this.cu_menuobj[2].span = this.translate.instant("sidebar.ab");
    this.cu_menuobj[3].span = this.translate.instant("sidebar.ao");
    this.cu_menuobj[4].span = this.translate.instant("sidebar.ba");
  }
}
